import { TFunction } from 'i18next';
import {
    MeterSurveyRequestModelProductsEnum,
    MeterSurveyRequestModelHouseTypeEnum,
    MeterSurveyRequestModelHomeHeatingEnum,
    MeterSurveyRequestModelWaterHeatingEnum,
    MeterSurveyRequestModelYourPriorityEnum,
    MeterSurveyRequestModelHomeOwnershipEnum,
    MeterSurveyRequestModelHomeInsulationEnum,
} from '@swagger-http';

export interface FormOptions {
    text: string;
    value:
        | MeterSurveyRequestModelProductsEnum
        | MeterSurveyRequestModelHouseTypeEnum
        | MeterSurveyRequestModelHomeHeatingEnum
        | MeterSurveyRequestModelWaterHeatingEnum
        | MeterSurveyRequestModelYourPriorityEnum
        | MeterSurveyRequestModelHomeOwnershipEnum
        | MeterSurveyRequestModelHomeInsulationEnum
        | '1'
        | '0';
    disabled?: boolean;
}

export const getHomeType = (t: TFunction): FormOptions[] => [
    {
        text: t('Bungalow'),
        value: MeterSurveyRequestModelHouseTypeEnum.Bungalow,
    },
    {
        text: t('Detached house'),
        value: MeterSurveyRequestModelHouseTypeEnum.DetachedHouse,
    },
    {
        text: t('Flat'),
        value: MeterSurveyRequestModelHouseTypeEnum.Flat,
    },
    {
        text: t('Terraced house'),
        value: MeterSurveyRequestModelHouseTypeEnum.TerracedHouse,
    },
    {
        text: t('Semi-detached house'),
        value: MeterSurveyRequestModelHouseTypeEnum.SemiDetachedHouse,
    },
];

export const getHomeOwnership = (t: TFunction): FormOptions[] => [
    {
        text: t('Rent'),
        value: MeterSurveyRequestModelHomeOwnershipEnum.Rent,
    },
    {
        text: t('Own'),
        value: MeterSurveyRequestModelHomeOwnershipEnum.Own,
    },
];

export const getProducts = (t: TFunction): FormOptions[] => [
    {
        value: MeterSurveyRequestModelProductsEnum.Solar,
        disabled: false,
        text: t('Solar'),
    },
    {
        value: MeterSurveyRequestModelProductsEnum.SolarBattery,
        disabled: false,
        text: t('Solar & Battery'),
    },
    {
        value: MeterSurveyRequestModelProductsEnum.ElectricVehicle,
        disabled: false,
        text: t('Electric vehicle'),
    },
    {
        value: MeterSurveyRequestModelProductsEnum.EvChargePoint,
        disabled: false,
        text: t('EV charge point'),
    },
    {
        value: MeterSurveyRequestModelProductsEnum.AirSourceHeatPump,
        disabled: false,
        text: t('Air source heat pump'),
    },
    {
        value: MeterSurveyRequestModelProductsEnum.GroundSourceHeatPump,
        disabled: false,
        text: t('Ground source heat pump'),
    },
];

export const getHeating = (t: TFunction): FormOptions[] => [
    {
        value: MeterSurveyRequestModelHomeHeatingEnum.GasBoiler,
        text: t('Gas boiler'),
    },
    {
        value: MeterSurveyRequestModelHomeHeatingEnum.ElectricStorageHeater,
        text: t('Electric storage heater'),
    },
    {
        value: MeterSurveyRequestModelHomeHeatingEnum.OilBoiler,
        text: t('Oil boiler'),
    },
    {
        value: MeterSurveyRequestModelHomeHeatingEnum.LpgBoiler,
        text: t('LPG boiler'),
    },
    {
        value: MeterSurveyRequestModelHomeHeatingEnum.Coal,
        text: t('Coal'),
    },
    {
        value: MeterSurveyRequestModelHomeHeatingEnum.AirSourceHeatPump,
        text: t('Air source heat pump'),
    },
    {
        value: MeterSurveyRequestModelHomeHeatingEnum.GroundSourceHeatPump,
        text: t('Ground source heat pump'),
    },
    {
        value: MeterSurveyRequestModelHomeHeatingEnum.Others,
        text: t('Others'),
    },
];

export const getWaterHeating = (t: TFunction): FormOptions[] => [
    {
        value: MeterSurveyRequestModelWaterHeatingEnum.Gas,
        text: t('Gas'),
    },
    {
        value: MeterSurveyRequestModelWaterHeatingEnum.Electricity,
        text: t('Electricity'),
    },
    {
        value: MeterSurveyRequestModelWaterHeatingEnum.Oil,
        text: t('Oil'),
    },
];

export const getHomeInsulation = (t: TFunction): FormOptions[] => [
    {
        value: MeterSurveyRequestModelHomeInsulationEnum.LoftInsulation,
        text: t('Loft insulation'),
    },
    {
        value: MeterSurveyRequestModelHomeInsulationEnum.CavityWall,
        text: t('Cavity wall'),
    },
    {
        value: MeterSurveyRequestModelHomeInsulationEnum.SolidWall,
        text: t('Solid wall'),
    },
    {
        value: MeterSurveyRequestModelHomeInsulationEnum.DoubleGlazedWindows,
        text: t('Double glazed windows'),
    },
    {
        value: MeterSurveyRequestModelHomeInsulationEnum.Nothing,
        text: t('None of the above'),
    },
];

export const getYourPriority = (t: TFunction): FormOptions[] => [
    {
        value: MeterSurveyRequestModelYourPriorityEnum.SavingMoneyAndEnergy,
        text: t('Saving money and energy'),
    },
    {
        value: MeterSurveyRequestModelYourPriorityEnum.ReduceCarbon,
        text: t('Being green and reduce carbon'),
    },
    {
        value: MeterSurveyRequestModelYourPriorityEnum.SelfSufficient,
        text: t('Becoming more self-sufficient'),
    },
    {
        value: MeterSurveyRequestModelYourPriorityEnum.ControlAndConvenience,
        text: t('Have better control and convenience'),
    },
];

export const getBooleanOptions = (t: TFunction): FormOptions[] => [
    {
        value: '1',
        text: t('Yes'),
    },
    {
        value: '0',
        text: t('No'),
    },
];
